export default __webpack_public_path__ + "static/media/transact-switch.49416d20.png";